import {
  createSetSearchParams,
  createSetTravelerInformation,
  createSetBrowseParams,
} from './setSearchParams';
import { browseParamsVar, searchParamsVar } from '../reactiveVariables';

export const setSearchParams = createSetSearchParams(searchParamsVar);
export const setTravelerInformation = createSetTravelerInformation(searchParamsVar);
export const setBrowseParams = createSetBrowseParams(browseParamsVar);
